/**
 * Auth Layout
 *
 * Minimal platform-branded layout for authentication routes:
 * /login, /authenticate, /complete-onboarding, /logout, /invitation/accept
 *
 * - Platform branding (logo + name) without the full AppNav
 * - No Sanity CMS integration
 * - No campaign cookie tracking
 * - Clean, centered layout suitable for login/signup/onboarding flows
 */

import { Link, Outlet } from "react-router";

export default function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-base-200">
      {/* Main content */}
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
